/**
 * 二手车统计
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock= //1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 二手车详情+get
// 接口地址  /api/v1/used_car/monthly_stat
Mock.mock(/used_car\/monthly_stat/, 'get' + mockSwitch, {
  'code': 0,
  'message': '201',
  'data': {
    'last_month': {
      'car_visit': {
        'sales': {
          'appraised': 26,
          'appraise_rate': 0.5157894736842105,
          'car_release': 131,
          'satisfy_solicit_rule': 30
        },
        'service': {
          'appraised': 10,
          'appraise_rate': 0,
          'car_release': 13,
          'satisfy_solicit_rule': 10
        }
      },
      'month': '2018-01',
      'source': {
        'internal': {
          'appraised': 20,
          'finished': 19,
          'finished_rate': 0.27941176470588236,
          'used_car': 68
        },
        'mp': {
          'appraised': 20,
          'finished': 20,
          'finished_rate': 0,
          'used_car': 24
        },
        'sales': {
          'appraised': 21,
          'finished': 21,
          'finished_rate': 0.3333333333333333,
          'used_car': 27
        },
        'service': {
          'appraised': 31,
          'finished': 31,
          'finished_rate': 0.25,
          'used_car': 8
        },
        'total': {
          'appraised': 311,
          'finished': 301,
          'finished_rate': 0.2564102564102564,
          'used_car': 117
        }
      },
      'summary': {
        'appraised': 21,
        'avg_price': 133975155.6071,
        'closed': 44,
        'finished': 518
      }
    },
    'this_month': {
      'car_visit': {
        'sales': {
          'appraised': 16,
          'appraise_rate': 0.3157894736842105,
          'car_release': 191,
          'satisfy_solicit_rule': 10
        },
        'service': {
          'appraised': 40,
          'appraise_rate': 0,
          'car_release': 43,
          'satisfy_solicit_rule': 40
        }
      },
      'month': '2018-02',
      'source': {
        'internal': {
          'appraised': 20,
          'finished': 19,
          'finished_rate': 0.27941176470588236,
          'used_car': 68
        },
        'mp': {
          'appraised': 10,
          'finished': 10,
          'finished_rate': 0,
          'used_car': 14
        },
        'sales': {
          'appraised': 91,
          'finished': 91,
          'finished_rate': 0.3333333333333333,
          'used_car': 27
        },
        'service': {
          'appraised': 21,
          'finished': 21,
          'finished_rate': 0.25,
          'used_car': 8
        },
        'total': {
          'appraised': 311,
          'finished': 301,
          'finished_rate': 0.2564102564102564,
          'used_car': 117
        }
      },
      'summary': {
        'appraised': 31,
        'avg_price': 133975155.6071,
        'closed': 24,
        'finished': 218
      }
    }
  }
})
